export const L10N = {
  ACTION_VIEW_MORE: { id: 'common.action.view_more' },
};
